import { connect } from 'react-redux'
import { purgeState } from '../../../utils/localStorage'
import { getUser } from '../selectors'
import Logout from '../components/logout'

const mapStateToProps = state => ({
  user: getUser(state),
  logout: () => {
    purgeState()
    window.location.reload()
  },
})

export default connect(
  mapStateToProps,
  null,
)(Logout)



// WEBPACK FOOTER //
// ./src/modules/admin/containers/logout.js